export const getSessionInfo = function () {
	return fetch('/actions/users/session-info', {
		headers: {
			Accept: 'application/json'
		}
	}).then((response) => response.json())
}

export const isSafariBrowser = () => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}

export const isFirefoxBrowser = () => {
  return navigator.userAgent.toLowerCase().includes('firefox');
}

export default () => {}
